module.exports = __webpack_public_path__ + "img/logo-maqr.d677fb09.svg";